import React from 'react';

import PatentFile from 'src/standard/components/patent-file/patent-file';

export default function CreateNewStandardEAPatents() {

	return (
		<>
			<PatentFile downloadTitle={'ASD-STAN Patent Declaration Form'} />
		</>
	);
}
